import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "sending-form-wrap" }
const _hoisted_2 = { class: "to-wrap" }

import { onMounted, reactive, ref } from 'vue';
import type { FormInstance } from 'element-plus';

import { CirclePlus, Delete } from '@element-plus/icons-vue';
import sendEmail from '@/api/formRequests';
import { FormFieldsType, FormStateType, ToItemType } from '@/types/SendEmailTypes';
import { getDocuments } from '@/api/documentRequests';
import { isMobile } from '@/helpers/breakpoints';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendingEmail',
  setup(__props) {


const ruleFormRef = ref<FormInstance>();

const ruleForm = reactive<FormFieldsType>({
  emails: [
    {
      key: 1,
      value: '',
    },
  ],
  name: '',
  company: '',
  docId: [],
});

const formState = reactive<FormStateType>({
  isError: false,
  isSuccess: false,
  isLoading: false,
  docsList: null,
});

onMounted(async () => {
  const data = await getDocuments();
  formState.docsList = data.map(({ id, title }) => ({ id, title }));
});

const labelTo = (value: number) => {
  if (value !== 0) {
    return null;
  }

  return 'Emails';
};

const handleDisableAddBtn = () => {
  const { emails } = ruleForm;
  return emails.length > 4;
};

const addAnotherMail = (key: number) => {
  ruleForm.emails.push({
    key: key + 1,
    value: '',
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
};

const removeMail = (item: ToItemType) => {
  const index = ruleForm.emails.indexOf(item);
  if (index !== -1) {
    ruleForm.emails.splice(index, 1);
  }
};

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      formState.isError = false;
      formState.isLoading = true;
      formState.isSuccess = false;
      sendEmail(ruleForm).catch(() => {
        formState.isError = true;
        formState.isLoading = false;
      }).finally(() => {
        formState.isLoading = false;
        formState.isSuccess = true;
        formEl.resetFields();
      });
    }
  });
};


return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (formState.isError)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          title: "There is an error",
          type: "error"
        }))
      : _createCommentVNode("", true),
    (formState.isSuccess)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 1,
          title: "Your email has been sent",
          type: "success"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: ruleForm,
      "label-width": "80px",
      "label-position": _unref(isMobile) ? 'top' : 'left',
      size: "large",
      class: "sending-form",
      disabled: formState.isLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "File",
          prop: "docId",
          rules: {
      required: true,
      message: 'Please select file',
      trigger: 'change',
    }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.docId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.docId) = $event)),
              placeholder: "Select File",
              multiple: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formState.docsList, (docsList) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: docsList.id,
                    label: docsList.title,
                    value: docsList.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleForm.emails, (email, index) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            key: email.key,
            label: labelTo(index),
            prop: 'emails.' + index + '.value',
            rules: [
    {
      required: true,
      message: 'Please input email address',
      trigger: 'blur',
    },
    {
      type: 'email',
      message: 'Please input correct email address',
      trigger: ['blur', 'change'],
    },
  ]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_input, {
                  modelValue: email.value,
                  "onUpdate:modelValue": ($event: any) => ((email.value) = $event),
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _withDirectives(_createVNode(_component_el_button, {
                  onClick: _withModifiers(($event: any) => (removeMail(email)), ["prevent"]),
                  icon: _unref(Delete),
                  class: "to-wrap__button"
                }, null, 8, ["onClick", "icon"]), [
                  [_vShow, email.key !==1]
                ]),
                _withDirectives(_createVNode(_component_el_button, {
                  onClick: _withModifiers(($event: any) => (addAnotherMail(email.key)), ["prevent"]),
                  icon: _unref(CirclePlus),
                  class: "to-wrap__button",
                  disabled: handleDisableAddBtn()
                }, null, 8, ["onClick", "icon", "disabled"]), [
                  [_vShow, email.key === 1]
                ])
              ])
            ]),
            _: 2
          }, 1032, ["label", "prop"]))
        }), 128)),
        _createVNode(_component_el_form_item, {
          label: "Name",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.name) = $event)),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Company",
          prop: "company"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.company,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.company) = $event)),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(ruleFormRef.value))),
              loading: formState.isLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Send")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (resetForm(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "label-position", "disabled"])
  ]))
}
}

})